{
  "themes_list_page": {
    "title": "Templates",
    "description": "Templates let you customise specific content your B2B customers see.",
    "footer": "Learn more about how templates work",
    "create_button": "Create Theme",
    "table": {
      "caption": "Table of all your templates",
      "headings": {
        "name": "Name",
        "updated": "Date Updated"
      },
      "published": "Published"
    },
    "menu": {
      "edit_code": "Edit Code",
      "publish": "Publish",
      "rename": "Rename",
      "download": "Download",
      "upload": "Upload",
      "delete": "Delete"
    },
    "media": {
      "pdfs": {
        "title": "Customise PDFs",
        "description": "Amend the current invoice and quote PDFs or start afresh and create your own."
      },
      "emails": {
        "title": "Customise email notifications",
        "description": "Edit the look and feel of specific emails sent from SparkLayer."
      }
    },
    "empty": {
      "title": "Edit content your B2B customers see with templates.",
      "subtitle": "Templates let you customise specific B2B content within your store such as invoices, email notifications, and language translations.",
      "available_on": "Available exclusively on",
      "pro": "Pro",
      "learn_button": "Learn how templates work",
      "intro": "Here are just some of the things you can do with templates:",
      "features": {
        "emails": {
          "title": "Customise email notifications",
          "description": "Edit the look and feel of specific emails sent from SparkLayer."
        },
        "pdfs": {
          "title": "Customise PDFs",
          "description": "Amend the current invoice and quote PDFs or start afresh and create your own."
        }
      },
      "note": "Please note: Templates are an advanced feature of SparkLayer and require technical expertise to implement. We strongly recommend working with a developer before creating a template.",
      "learn_more_link": "Learn more about how templates work"
    },
    "modals": {
      "name_label": "Name",
      "create": {
        "title": "Create Theme"
      },
      "rename": {
        "title": "Rename Theme"
      },
      "upload": {
        "title": "Upload Template Files",
        "description": "Please add a zip file containing the template files.",
        "submit": "Upload Files",
        "errors_intro": "There were issues found, please review these before continuing.",
        "invalid_zip": "Invalid zip file.",
        "line_error": "Line {line} ({field}): {message}",
        "generic_error": "An issue occurred, please contact support."
      },
      "delete": {
        "title": "Delete Theme",
        "message": "Are you sure you want to delete the theme \"{name}\"?",
        "not_found": "The theme \"{name}\" does not exist",
        "failed": "Failed to delete the theme \"{name}\", please try again later"
      }
    },
    "notifications": {
      "uploaded": "Template files successfully uploaded."
    }
  },
  "theme_editor_page": {
    "back": "Back",
    "back_to_templates": "Back To Templates",
    "add_file_button": "Add Template File",
    "open_a_file": "Open a file to begin",
    "open_a_file_hint": "Select a template file from the sidebar to start editing.",
    "unknown_theme": "Unknown template, please go back.",
    "empty_title": "\"{name}\" has no custom template files yet",
    "empty_subtitle": "Let's start by adding a template file to customise!",
    "revisions": "Revisions",
    "open_files": "Open files",
    "close_files": "Close files",
    "close_file": "Close",
    "unsaved_changes": "Unsaved Changes",
    "close_unsaved_message": "\"{slug}\" has unsaved changes. Are you sure you want to close this file?",
    "delete_file_title": "Delete template file",
    "delete_file_message": "Are you sure you want to delete the \"{slug}\" template file?",
    "file_types": {
      "email": "Emails",
      "pdf": "PDFs",
      "section": "Sections",
      "language": "Language Files"
    },
    "add_file": {
      "title": "Add Template File",
      "subheading": "Customise emails and PDFs by adding a new Template File to edit.",
      "file_types": "File Types",
      "select_placeholder": "Select a file",
      "none_available": "No more template files available",
      "submit": "Add File",
      "error": "An error occurred while creating the file, please try again or contact support."
    },
    "preview": {
      "open": "Open preview",
      "error": "Unable to render the preview. Please try again.",
      "unsaved_hint": "Save your changes to preview them"
    },
    "notifications": {
      "invalid_syntax": "Invalid Syntax"
    }
  }
}
